import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=9231fd6a&"
import script from "./attr.vue?vue&type=script&lang=js&"
export * from "./attr.vue?vue&type=script&lang=js&"
import style0 from "./attr.vue?vue&type=style&index=0&id=9231fd6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports